// src/ClientRoutes.js
import React, { useEffect, useState } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import "../src/styles/globals.css";
import "../src/styles/reports.css";

import Login from './Client/Components/ClientLogin/Login';
import OtpVerification from './Client/Components/ClientLogin/OtpVerification';
import Cart from './Client/Components/Order/Cart';
import Home from './Client/Components/Home/Homepage';
import Header from "./Client/Components/Header/Header";
import Footer from "./Client/Components/Footer/Footer";
import CategoryPage from './Client/Components/Category/CategoryPage';
import TestDetailPage from './Client/Components/Category/TestDetail';
import CouponsPage from './Client/Components/Offers/Coupons';
import { CartProvider } from './Services/CartContext';
import BookTests from './Client/Components/Category/BookTestsPage';
import Address from './Client/Components/Profile/Address';
import Orders from './Client/Components/Profile/Orders';
import MemberDetails from './Client/Components/Profile/MemberDetails';
import OrderDetails from './Client/Components/Profile/OrderDetails';
import PrivateRoute from './Services/ClientPrivateRoute';
import PackageDetailPage from './Client/Components/Category/PackageDetail';
import Profile from './Client/Components/Profile/Profile';
import RecommendedCheckup from './Client/Components/Category/RecommendedCheckup';
import Signup from './Client/Components/ClientLogin/Signup';
import OtpVerificationSignup from './Client/Components/ClientLogin/OtpVerificationSignup';
import CompleteProfile from './Client/Components/ClientLogin/CompleteProfile';
import PhlebloSignup from './Client/Components/ClientLogin/PhlebloSignup';

import Dashboard from './Client/Components/ScanReports/Dashboard';
import ReportsHeader from './Client/Components/ScanReports/ReportsHeader';
import Sidebar from './Client/Components/ScanReports/Sidebar';
import MobileTabs from './Client/Components/ScanReports/MobileTabs';
import HealthReports from './Client/Components/ScanReports/HealthReports';
import Prescriptions from './Client/Components/ScanReports/Prescriptions';
import PrescriptionDetails from './Client/Components/ScanReports/PrescriptionDetails';
import BillsReceipts from './Client/Components/ScanReports/BillsReceipts';
import Scanner from './Client/Components/ScanReports/Scanner';
import FileUpload from './Client/Components/Aireports/FileUpload';


const ClientRoutes = () => {
  const location = useLocation();
  const isReportsRoute = location.pathname.startsWith("/reports");
  const hideHeaderFooter =
    ["/login", "/otp-verification"].includes(location.pathname) || ["/register"].includes(location.pathname)||["/signup-otp-verification"].includes(location.pathname)||["/complete-rofile"].includes(location.pathname)||["/phleblotomist-registration"].includes(location.pathname)|| isReportsRoute;

  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const loggedIn = localStorage.getItem("isLoggedIn") === "true";
    setIsLoggedIn(loggedIn);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("isLoggedIn");
    setIsLoggedIn(false);
  };

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <>
      {!isReportsRoute ? (
        <CartProvider>
          <div className="client-app">
            {!hideHeaderFooter && <Header />}

            <Routes>
              <Route path="/" element={<Home logoSrc="/images/pranaam-365-logo.png" />} />
              <Route path="/login" element={<Login />} />
              <Route path="/otp-verification" element={<OtpVerification />} />
              <Route path="/register" element={<Signup />} />
              <Route path="/signup-otp-verification" element={<OtpVerificationSignup />} />
              <Route path="/complete-rofile" element={<CompleteProfile />} />
              <Route path="/:category" element={<CategoryPage />} />
              <Route path="/recommended-checkups/:Slug" element={<RecommendedCheckup />} />
              <Route path="/:category/:testSlug" element={<TestDetailPage />} />
              <Route path="/package/:testSlug" element={<PackageDetailPage />} />
              <Route path="/cart" element={<PrivateRoute element={Cart} /> }  />
              <Route path="/coupons" element={<PrivateRoute element={CouponsPage} />} />
              <Route path="/book-tests" element={<BookTests />} />
              <Route path="/address" element={<PrivateRoute element={Address} />} />
              <Route path="/profile" element={<PrivateRoute element={Profile} />} />
              <Route path="/orders" element={<PrivateRoute element={Orders} />} />
              <Route path="/order-details/:orderId" element={<PrivateRoute element={OrderDetails} />} />
              <Route path="/member-details" element={<PrivateRoute element={MemberDetails} />} />
              <Route path="/ai" element={<PrivateRoute element={FileUpload} />} />
              <Route path="/phleblotomist-registration" element={<PhlebloSignup />} />
            </Routes>

            {!hideHeaderFooter && <Footer />}
          </div>
        </CartProvider>
      ) : (
        <div className="dashboard-container reports-container">
          <ReportsHeader toggleSidebar={toggleSidebar} handleLogout={handleLogout} />
          <div className="dashboard-content">
            <Sidebar isOpen={sidebarOpen} closeSidebar={() => setSidebarOpen(false)} />
            <main className="main-content">
              <Routes>
                {/* <Route path="/reports" element={<Dashboard />} />
                <Route path="/reports/dashboard" element={<Dashboard />} /> */}
                <Route path="/reports/:test" element={<HealthReports />} />
                <Route path="/reports/prescriptions" element={<Prescriptions />} />
                <Route path="/reports/prescription-details" element={<PrescriptionDetails />} />
                <Route path="/reports/bills-receipts" element={<BillsReceipts />} />
                <Route path="/reports/scanner" element={<Scanner />} />
              </Routes>
            </main>
          </div>
          <MobileTabs />
        </div>
      )}
    </>
  );
};

export default ClientRoutes;
